export function InfoIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.8 7.29C13 7.11 13.24 7 13.5 7C13.77 7 14 7.11 14.21 7.29C14.4 7.5 14.5 7.74 14.5 8C14.5 8.27 14.4 8.5 14.21 8.71C14 8.9 13.77 9 13.5 9C13.24 9 13 8.9 12.8 8.71C12.61 8.5 12.5 8.27 12.5 8C12.5 7.74 12.61 7.5 12.8 7.29ZM10.3 11.97C10.3 11.97 12.47 10.25 13.26 10.18C14 10.12 13.85 10.97 13.78 11.41L13.77 11.47C13.63 12 13.46 12.64 13.29 13.25C12.91 14.64 12.54 16 12.63 16.25C12.73 16.59 13.35 16.16 13.8 15.86C13.86 15.82 13.91 15.78 13.96 15.75C13.96 15.75 14.04 15.67 14.12 15.78C14.14 15.81 14.16 15.84 14.18 15.86C14.27 16 14.32 16.05 14.2 16.13L14.16 16.15C13.94 16.3 13 16.96 12.62 17.2C12.21 17.47 10.64 18.37 10.88 16.62C11.09 15.39 11.37 14.33 11.59 13.5C12 12 12.18 11.32 11.26 11.91C10.89 12.13 10.67 12.27 10.54 12.36C10.43 12.44 10.42 12.44 10.35 12.31L10.32 12.25L10.27 12.17C10.2 12.07 10.2 12.06 10.3 11.97ZM22.5 12C22.5 17.5 18 22 12.5 22C7 22 2.5 17.5 2.5 12C2.5 6.5 7 2 12.5 2C18 2 22.5 6.5 22.5 12ZM20.5 12C20.5 7.58 16.92 4 12.5 4C8.08 4 4.5 7.58 4.5 12C4.5 16.42 8.08 20 12.5 20C16.92 20 20.5 16.42 20.5 12Z"
				fill="#1A73E8"
			/>
		</svg>
	);
}
